<script>
  let { label, tone = 'ghost' } = $props()

  const TONE_CLASSES = {
    success: 'badge badge-success',
    warning: 'badge badge-warning',
    error: 'badge badge-error',
    info: 'badge badge-info',
    neutral: 'badge badge-neutral',
    secondary: 'badge badge-secondary',
    ghost: 'badge badge-ghost'
  }
</script>

<span class={TONE_CLASSES[tone] || TONE_CLASSES.ghost}>{label}</span>
